/**
 * HQ › Centre Operations › Maintenance checklist.
 *
 * Opens on how every centre is doing, day by day (the same table as Centre
 * Health › Centre Ops › Maintenance Checklist: submitted / missed squares per
 * centre, done of due). The checkpoint editor that used to be the whole page
 * stays one tab away, for whoever maintains the checklists (2026-10-15).
 */
import { Tab, Tabs } from '@material-ui/core'
import React, { useState } from 'react'

import CentreOpsReport from 'app/pages/Operations/CentreOpsReport'

import ChecklistSetup from './ChecklistSetup'

const ChecklistHq = () => {
  const [tab, setTab] = useState('status')
  return (
    <div>
      <Tabs
        value={tab}
        onChange={(e, value) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
        style={{ padding: '0 24px' }}
      >
        <Tab
          value="status"
          label="Centre status"
          style={{ textTransform: 'none' }}
        />
        <Tab
          value="setup"
          label="Checkpoints"
          style={{ textTransform: 'none' }}
        />
      </Tabs>
      {tab === 'status' ? (
        <CentreOpsReport
          only="checklist"
          title="Maintenance Checklist — all centres"
        />
      ) : (
        <ChecklistSetup />
      )}
    </div>
  )
}

export default ChecklistHq
